import _ from 'lodash';

/**
 *
 */
class dialogLoader {
  constructor() {
    this.delegate = [];
  }

  /**
   * 登録
   * @param {function} func
   */
  setDelegate(func) {
    this.delegate.push(func);
  }

  handleClosePreviousDialog = () => {
    this.close();
  };

  /**
   * コンポーネントを返す
   */
  show(component, state, data = null) {
    window.addEventListener('popstate', this.handleClosePreviousDialog);
    _.each(this.delegate, func => {
      if (func) {
        // dataが存在した場合はstateへ格納
        if (data) {
          state.callback.data = data;
        }
        func(component, state);
      }
    });
  }

  close() {
    window.removeEventListener('popstate', this.handleClosePreviousDialog);
    _.each(this.delegate, func => {
      if (func) {
        func(null);
      }
    });
  }

  /**
   * 表示しているダイアログにデータを渡す
   * @param component {string}
   * @param state {func}
   * @param data {any} 渡したいデータ
   */
  redraw(component, state, data) {
    _.each(this.delegate, func => {
      if (func) {
        state.callback.data = data;
        func(component, state);
      }
    });
  }
}

const _dialogLoader = new dialogLoader();
export default _dialogLoader;



// WEBPACK FOOTER //
// ./src/utilities/dialogLoader.js